var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"roll-num"},[_vm._l((_vm.nums),function(item){return [(item.point)?_c('span',[_vm._v(".")]):_c('DigitRoll',{attrs:{"rollDigits":item.n,"dur":item.dur}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }